// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        containedInherit: {
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
          boxShadow: theme.customShadows.z8,
          color: theme.palette.grey[800],
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          border: `1px solid ${theme.palette.grey[500_32]}`,
        },
        root: {
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
